import type { ReactNode } from "react";
import { FilterChip } from "./FilterChip";
import { FilterChip as FilterChipV2 } from "./FilterChipV2";
import { useMemberFilterDesign } from "./MemberFilterDesignContext";

interface FilterChipProps {
  children: ReactNode;
  "data-testid"?: string;
  renderSelectedValue: () => ReactNode;
  shouldShowClearButton?: boolean;
}

export const FilterChipWrapper = (props: FilterChipProps) => {
  const isMemberFilterDesignEnabled = useMemberFilterDesign();

  if (isMemberFilterDesignEnabled) {
    return <FilterChipV2 {...props} />;
  }

  return <FilterChip {...props} />;
};
